import type { ReactNode } from 'react'
import { toneClass, type ChipTone } from './tokens'

export const StatusBar = ({
  tone,
  title,
  detail,
  meta,
  note,
  action,
  icon,
  live = 'status',
}: {
  tone: ChipTone
  title: string
  detail?: ReactNode
  meta?: ReactNode
  note?: ReactNode
  action?: ReactNode
  icon?: ReactNode
  live?: 'status' | 'alert' | 'none'
}) => (
  <div className={`status-notice ${toneClass(tone)}`} role={live === 'none' ? undefined : live}>
    {icon === undefined ? null : (
      <span className="status-notice-icon" aria-hidden="true">
        {icon}
      </span>
    )}
    <div className="status-notice-text">
      <strong className="status-notice-title">{title}</strong>
      {detail === undefined ? null : <span className="status-notice-detail">{detail}</span>}
      {meta === undefined ? null : <span className="status-notice-meta num">{meta}</span>}
      {note === undefined ? null : <span className="status-notice-note">{note}</span>}
    </div>
    {action === undefined ? null : <div className="status-notice-action">{action}</div>}
  </div>
)
